// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"oIYry5eGHJ78mGYu3H_Ul","btn-outlet":"_2SplPI6m6fIIknaqsXkxX_"};